import { parse } from 'querystring';
import pathRegexp from 'path-to-regexp';
import { format } from 'date-fns';
// import { EMPTY_VALUE } from '@/utils/properties'

const EMPTY_VALUE = Symbol('empty').toString();

export interface SelectionItem {
  value: any;
  label: string;
}

/** 图片加载失败显示图 */
export const fallbackData =
  'data:image/png;base64,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';
const isUrlReg =
  /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

/**
 * 测试是否为url
 * @author Carson
 * */
export const isUrl = (path: string): boolean => isUrlReg.test(path);

export const isAntDesignPro = (): boolean => {
  if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
    return true;
  }
  return window.location.hostname === 'preview.pro.ant.design';
};

// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
  const { NODE_ENV } = process.env;
  if (NODE_ENV === 'development') {
    return true;
  }
  return isAntDesignPro();
};

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export function getDate(offset = 0): Date {
  const date: Date = new Date();
  if (offset !== 0) {
    date.setTime(date.getTime() + 86400000 * offset);
  }
  return date;
}

/**
 * 时间格式化
 * @author carson
 */
export function formatDayData(date: Date = new Date()) {
  return {
    date: date.getDate(), // 几号
    day: date.getDay(), // 周几
    month: date.getMonth() + 1, // 月份（实际月份）
    year: date.getFullYear(), // 年份
    fullDate: format(date, 'yyyy-MM-dd'),
  };
}

/**
 * 千分位格式化
 * @author carson
 */
export function moneyFormatter(money: string | number): string {
  return `${money}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 将枚举值转换为Object
 * @author carson
 */
export function generateSelections(dataSource: object): SelectionItem[] {
  const result: SelectionItem[] = [];
  Object.entries(dataSource).forEach(([key, value]) => {
    result.push({
      value: key,
      label: value,
    });
  });
  return result;
}

// function temperatureTransfer(temperature: number, form: string, to: string) {}
export function StingToArray(stringData: string, separator: string = ''): string[] {
  if (!stringData) {
    return [];
  }
  return stringData.split(separator);
}

export function ArrayToString(arrayData: any[], separator: string = ''): string {
  return arrayData.join(separator);
}

// 根据环境重置域名
export const resetHost = (baseURL: string) => {
  const host = baseURL.split('.');
  // 这里有个奇怪的bug，不这样写会在控制台报：ReferenceError: window is not defined
  if (typeof window !== 'undefined') {
    host[0] = host[0].replace(/gray|test/g, '');
    const ENV_IS_GRAY = /gray/g.test(window.location.host);
    const ENV_IS_TEST = /test|localhost/g.test(window.location.host);
    host[0] = host[0].replace(/gray|test/g, '');
    if (ENV_IS_TEST) {
      host[0] += 'test';
    } else if (ENV_IS_GRAY) {
      host[0] += 'gray';
    }
  }
  return host.join('.');
};

/**
 * @description: 总秒数 转化为 时分秒
 * @param {any} value
 * @return {*}
 */
export const formatSeconds = (value: number = 0) => {
  let theTime: number = value; // 秒
  let theTime1: number = 0; // 分
  let theTime2: number = 0; // 小时
  if (theTime > 60) {
    theTime1 = Math.floor(theTime / 60);
    theTime = Math.floor(theTime % 60);
    if (theTime1 > 60) {
      theTime2 = Math.floor(theTime1 / 60);
      theTime1 = Math.floor(theTime1 % 60);
    }
  }
  let result: string = `${Math.floor(theTime)}`;
  if (Number(result) < 10) {
    result = `0${result}`;
  }
  if (theTime1 > 0) {
    result = `${Math.floor(theTime1)}:${result}`;
    if (theTime1 < 10) {
      result = `0${result}`;
    }
  } else {
    result = `00:${result}`;
  }
  if (theTime2 > 0) {
    result = `${Math.floor(theTime2)}:${result}`;
    if (theTime2 < 10) {
      result = `0${result}`;
    }
  } else {
    result = `00:${result}`;
  }
  return result;
};

type Range = number | [min?: number, max?: number] | { min?: number; max?: number };

/**
 * @description: 是否在区间内
 * @param { number } value 要判断的值
 * @param { Range } range 区间
 * @param { boolean } autoFixRange 自动修复区间错误，如[100, 1] => [1, 100]，{ min: 100, max: 1} => { min: 1, max: 100}
 * @return boolean
 */
export function isInRange(value: number, range: Range, autoFixRange: boolean = true) {
  const val = Number(value);
  if (typeof range === 'number') {
    return val === range;
  }
  let min: any;
  let max: any;
  if (range instanceof Array) {
    [min, max] = range;
  } else if (typeof range === 'object') {
    min = range.min;
    max = range.max;
  }
  // 重排最大最小值
  if (min && min && autoFixRange) {
    [min, max] = [min, max].sort((a, b) => (a || b) && a - b);
  }
  if (min || max) {
    if (!min) {
      return val <= max;
    }
    if (!max) {
      return val >= min;
    }
    return val >= min && val <= max;
  }
  return true;
}

// 过滤空值
export const clearEmptyField = (fields: any) => {
  if (fields) {
    const nextFields = { ...fields };
    Object.entries(nextFields).forEach(([k, v]) => {
      if (v instanceof Array) {
        nextFields[k] = v.filter((item) => item !== EMPTY_VALUE);
      } else if (v instanceof Object) {
        nextFields[k] = clearEmptyField(v);
      } else if (v === EMPTY_VALUE) {
        nextFields[k] = '';
      }
      if (v === undefined || v === null || (v instanceof Array && v.length <= 0)) {
        delete nextFields[k];
      }
    });
    return nextFields;
  }
  return fields;
};

// 是否为临时定向包
export const isTempTargetingID = (targetingID: string) =>
  !!targetingID && /temp_targeting_/g.test(targetingID);

export const proStorage = {
  save(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  fetch(key: string) {
    return JSON.parse(localStorage.getItem(key) || '{}');
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
};

// 对象深拷贝
export const __deepcopyObj = function (obj: any) {
  let res = typeof obj === 'object' ? JSON.parse(JSON.stringify(obj)) : obj;
  obj = null;
  setTimeout(() => {
    res = null;
  }, 0);
  return res;
};

export const __deepcopyObj2 = function (initalObj: any, finalObj?: any) {
  var obj = finalObj || {};
  for (var i in initalObj) {
    var prop = initalObj[i]; // 避免相互引用对象导致死循环，如initalObj.a = initalObj的情况
    if (prop === obj) {
      continue;
    }
    if (typeof prop === 'object') {
      obj[i] = prop.constructor === Array ? [] : {};
      arguments.callee(prop, obj[i]);
    } else {
      obj[i] = prop;
    }
  }
  return obj;
};

export function getQueryString(name: string, url: string) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = url.match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

export function isNotEmpty(val: any) {
  return val || val === 0 ? val : '-';
}

/**
 * 是否为指定类型
 * @param v 要检测的变量
 * @param t 指定的类型
 * @returns 布尔类型
 */
export function isType(v: any, t: 'Array' | 'Object' | 'Number' | 'String') {
  return Object.prototype.toString.call(v) === `[object ${t}]`;
}
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
/**
 * 获取 URL 参数
 */
export function getUrlParams(url:string) {
  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split('?')[1]
  // 创建空对象存储参数
let obj = {};
  // 再通过 & 将每一个参数单独分割出来
let paramsArr = urlStr.split('&')
for(let i = 0,len = paramsArr.length;i < len;i++){
      // 再通过 = 将每一个参数分割为 key:value 的形式
  let arr = paramsArr[i].split('=')
  obj[arr[0]] = arr[1];
}
return obj
}
